<top-navig [display]="true" [displayLogo]="false" title="Restaurant"></top-navig>
<div class="info">
    <div class="container head" [@zoomIn]="true">
        <div *ngIf="pdv?.image" class="row image" oncontextmenu="return false;" [ngClass]="{loading:!loadAvatar}">
            <img loading [src]="pdv.image|absolutePath:'img'" style="position: relative" width="100%"
                (load)="loadAvatar=true">
        </div>
        <div class="row comment" *ngIf="pdv?.comment">
            <div class="col-md-12">
                <h3 class="heading">Le restaurant :</h3>
                <hr class="half_space">
                <div [innerHtml]="pdv?.comment| safeHtml" class="comment"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <h3 class="heading">Horaires d'ouverture</h3>
                <hr class="half_space">
                <div *ngIf="pdv?.openingtext" [innerHtml]="pdv?.openingtext| safeHtml" class="comment"></div>
            </div>
        </div>
        <div class="row livraison">
            <div class="col-md-12">
                <h3 class="heading">Zones de livraison:</h3>
                <hr class="half_space">
                <div *ngIf="authorizedCities?.length==0">Acune zone de livraison disponible.</div>
                <table width="100%" class="table-striped" *ngIf="authorizedCities?.length>0">
                    <thead>
                        <th>Zone</th>
                        <th>Min de commande</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let zone of authorizedCities;">
                            <td>
                                <a href="/commander/livraison-{{pdv.speciality}}-{{ zone.name | lowercase }}-{{
                                    zone.postalCode
                                  }}"
                                    title="livraison {{zone.name}} {{zone.postalCode}}">{{zone.name}}
                                    {{zone.postalCode}}</a>
                            </td>
                            <td class="text-center">{{zone.amountMiniDelivery}}€</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-12">
                <h3 class="heading">Contact :</h3>
                <div class="contact-info  fadeInUp animated">
                    <div class="footer_column contact">
                        <hr class="half_space">
                        <p> <img src="assets/imgs/restaurant.svg" style="margin-right: 6px;" width="19px"
                                [alt]="pdv?.name">
                            {{pdv?.name}}
                        </p>
                        <p class="address">
                            <i class="flaticon-pin"></i>
                            <a #maplink href="#" target="_blank"> {{pdv?.address}}</a>
                        </p>
                        <p class="phone">
                            <i class="flaticon-phone-on-circle"></i>
                            <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
                        </p>
                        <p class="email" *ngIf="pdv?.emailContact">
                            <i class="flaticon-arroba"></i>
                            <a href="mailto:{{pdv?.emailContact}}">
                                <span>
                                    {{pdv?.emailContact}}
                                </span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="map"></div>
<ng-template #temp>
    Fermé
</ng-template>